import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';


// ===== SWIPER =====
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// ===== ICONOS =====
import {
  FaBolt, FaCoins, FaSmile, FaShoppingCart, FaGift, FaClock,
  FaShieldAlt, FaQrcode, FaCube, FaWallet, FaArrowRight,
  FaBuilding, FaCrown, FaRocket, FaChartLine, FaSpinner,
  FaCheckCircle, FaTimes
} from 'react-icons/fa';

// ===== ESTILOS E IMAGEN =====
import '../styles/Home.css';
import reanimeitorImage from '../Assets/reanimeitor-can.png.png';
import packImage from '../Assets/pack24.png';
import ShippingForm from '../components/ShippingForm';

const Home = () => {
  const [activeTab, setActiveTab] = useState('products');
  const [isMobile, setIsMobile] = useState(false);
  const [currentPack, setCurrentPack] = useState(0);
  const [user, setUser] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [purchasedPack, setPurchasedPack] = useState(null);
  const [purchasedBGP, setPurchasedBGP] = useState(0);

  const [showShippingForm, setShowShippingForm] = useState(false);
  const [selectedPack, setSelectedPack] = useState(null);

  const navigate = useNavigate();

  // Detectar móvil
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Cargar usuario
  const loadUser = async () => {
    try {
      const res = await axios.get('https://reanimeitor.com/backend/profile.php', {
        withCredentials: true
      });
      if (res.data.success && res.data.user) {
        setUser(res.data.user);
        localStorage.setItem('userData', JSON.stringify(res.data.user));
      } else {
        setUser(null);
        localStorage.removeItem('userData');
      }
    } catch (err) {
      setUser(null);
    }
  };

  useEffect(() => {
    loadUser();
  }, []);

  // Verificar pago
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const success = params.get('pack_success');
    const sessionId = params.get('session_id');
    if (success === 'true' && sessionId) {
      const verify = async () => {
        try {
          const res = await axios.post(
            'https://reanimeitor.com/backend/verify_payment.php',
            { session_id: sessionId },
            { withCredentials: true }
          );
          if (res.data.success && res.data.paid) {
            setPurchasedPack({ name: res.data.pack_name, bgp_tokens: res.data.bgp_tokens });
            setPurchasedBGP(res.data.bgp_tokens || 0);
            setShowSuccessPopup(true);
            await loadUser();

            // 🔥 GUARDA FLAG PARA QUE ACCOUNTPAGE SE RECARGUE
            sessionStorage.setItem('needsBalanceRefresh', 'true');

            window.history.replaceState({}, document.title, window.location.pathname);
          }
        } catch (err) {
          console.error(err);
        }
      };
      verify();
    }
  }, []);

  const packsData = [
    {
      id: 1,
      name: 'Genesis Pack',
      price: 20,
      bgpTokens: 2000,
      description: 'Acceso anticipado al ecosistema reanimeitor Trace. Incluye lata física de edición limitada.',
      features: [
        { icon: '🥫', label: '1 reanimeitor Genesis Can' },
        { icon: <FaCoins />, label: '2000 BGP tokens' },
        { icon: <FaRocket />, label: 'Acceso anticipado al proyecto' }
      ],
      badge: 'Edición Limitada',
      color: '#ffcc00'
    },
    {
      id: 2,
      name: 'Builder Pack',
      price: 35.76,
      bgpTokens: 4470,
      description: 'Prioridad en acceso a la plataforma y tokens BGP para desarrollo en el ecosistema.',
      features: [
        { icon: '🥫', label: '24 reanimeitor Genesis Can' },
        { icon: <FaCoins />, label: '4470 BGP tokens' },
        { icon: <FaChartLine />, label: 'Prioridad en acceso a la plataforma' }
      ],
      badge: 'Popular',
      color: '#60a5fa'
    },
    {
      id: 3,
      name: 'Founder License',
      price: 66.72,
      bgpTokens: 11120,
      description: 'Licencia fundacional con capacidad de registrar productos y uso prioritario del sistema.',
      features: [
        { icon: '🥫', label: '48 reanimeitor Genesis Can' },
        { icon: <FaCrown />, label: 'Acceso anticipado al sistema' },
        { icon: <FaQrcode />, label: 'Capacidad de registrar productos' },
        { icon: <FaCoins />, label: 'Uso de tokens BGP en el sistema' },
        { icon: <FaBolt />, label: 'Prioridad en integraciones futuras' }
      ],
      badge: 'Fundador',
      color: '#a855f7'
    }

  ];

  const formatPrice = (price) => {
    if (price >= 1000) {
      return `${(price / 1000).toFixed(0)}.${(price % 1000).toString().padStart(3, '0')}`;
    }
    return price.toString();
  };

  const handleBuy = (pack) => {
    if (!user) {
      localStorage.setItem('pending_pack', JSON.stringify(pack));
      navigate('/login');
      return;
    }
    setSelectedPack(pack);
    setShowShippingForm(true);
  };

  const handleShippingSuccess = async (shippingData) => {
    setShowShippingForm(false);
    setIsProcessing(true);
    try {
      const res = await axios.post(
        'https://reanimeitor.com/backend/create_stripe_session_pack.php',
        {
          user_id: user.id,
          pack_id: selectedPack.id,
          pack_name: selectedPack.name,
          amount: selectedPack.price,
          bgp_tokens: selectedPack.bgpTokens
        },
        { withCredentials: true }
      );
      if (res.data.success && res.data.checkoutUrl) {
        window.location.href = res.data.checkoutUrl;
      } else {
        alert('Error al crear sesión de pago: ' + (res.data.error || 'Intenta de nuevo'));
      }
    } catch (err) {
      alert('Error de conexión. Intenta de nuevo.');
    } finally {
      setIsProcessing(false);
    }
  };

  const nextPack = () => {
    setCurrentPack((prev) => (prev === packsData.length - 1 ? 0 : prev + 1));
  };
  const prevPack = () => {
    setCurrentPack((prev) => (prev === 0 ? packsData.length - 1 : prev - 1));
  };

  const scrollToPacks = () => {
    setActiveTab('products');
    setTimeout(() => {
      // Buscar el contenedor correcto según el dispositivo
      const packsSection = document.querySelector('.packs-layout, .packs-mobile-carousel-wrapper');
      if (packsSection) {
        packsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const statsData = [
    { value: '1500', label: 'Genesis Cans', icon: <FaBolt />, color: '#ffcc00' },
    { value: '1420', label: 'BGP Tokens Generados', icon: <FaCoins />, color: '#60a5fa' },
    { value: '98%', label: 'Satisfacción', icon: <FaSmile />, color: '#10b981' }
  ];

  const bgpInfoData = [
    {
      title: '¿Qué es Bitcoin Global Pay?',
      description: 'Token SPL en Solana vinculado al valor de 1 Reanimeitor. Cada BGP te da derecho a canjearlo por 1 lata física.',
      icon: <FaCube />,
      color: '#ffcc00',
      points: [
        '1 Reanimeitor = +BGP',
        'Tokens gratuitos incluido en los reanimeitors',
        'Acumulable y canjeable en exchange',
        'Sistema transparente blockchain'
      ]
    },
    {
      title: '¿Cómo obtener BGP?',
      description: 'Obtén tokens BGP de forma gratuita y acumula valor en el ecosistema',
      icon: <FaCoins />,
      color: '#60a5fa',
      points: [
        '🛒 Compra Reanimeitor: BGP gratis por lata',
        '💰 Compra directa: Adquiere BGP en mi cuenta',
        '⚡ Contador de retiro: Canjea cuando esté a 0',
        '🎁 Promociones especiales: BGP extra'
      ]
    }
  ];

  return (
    <div className="home-page">
      {showShippingForm && selectedPack && (
        <ShippingForm
          pack={selectedPack}
          user={user}
          onSuccess={handleShippingSuccess}
          onCancel={() => setShowShippingForm(false)}
        />
      )}

      {showSuccessPopup && purchasedPack && (
        <div className="success-popup-overlay">
          <div className="success-popup">
            <button className="popup-close-btn" onClick={() => setShowSuccessPopup(false)}>
              <FaTimes />
            </button>
            <div className="popup-icon">
              <FaCheckCircle />
            </div>
            <h3>¡Enhorabuena!</h3>
            <p className="popup-pack-name">Has comprado <strong>{purchasedPack.name}</strong></p>
            {purchasedBGP > 0 && (
              <p className="popup-bgp-reward">Has obtenido <strong>{purchasedBGP} BGP tokens</strong></p>
            )}
            <p className="popup-message">Tus tokens están disponibles a través de <strong>Mi Cuenta</strong></p>
            <div className="popup-actions">
              <button className="popup-btn primary" onClick={() => {
                setShowSuccessPopup(false);
                // Pequeño delay para asegurar que sessionStorage se guarde
                setTimeout(() => {
                  navigate('/account');
                }, 100);
              }}>
                <FaWallet /> Ir a Mi Cuenta
              </button>
              <button className="popup-btn secondary" onClick={() => setShowSuccessPopup(false)}>
                Seguir comprando
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="energy-field">
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-bolt"></div>
        <div className="energy-node"></div>
        <div className="energy-node"></div>
        <div className="energy-node"></div>
        <div className="energy-node"></div>
        <div className="energy-wave"></div>
      </div>

      {/* HERO SECTION */}
      <section className="home-hero">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-badge">
              <span className="badge-icon">⚡</span>
              <span className="badge-text">reanimeitor TRACE</span>
            </div>
            <h1 className="hero-title">
              <span className="title-line">reanimeitor</span>
              <span className="title-line-small">La revolución blockchain en autenticación</span>
            </h1>
            <div className="hero-description-wrapper">
              <p className="hero-description">
                Infraestructura global para autentificar productos mediante blockchain.
                <span className="highlight"> Acceso anticipado con Genesis Cans</span>
              </p>
            </div>
            <div className="hero-stats-mini">
              <div className="mini-stat">
                <span className="mini-stat-label">Genesis Cans</span>
                <span className="mini-stat-value">1500</span>
              </div>
              <div className="mini-stat-divider"></div>
              <div className="mini-stat">
                <span className="mini-stat-label">Tokens</span>
                <span className="mini-stat-value">BGP</span>
              </div>
              <div className="mini-stat-divider"></div>
              <div className="mini-stat">
                <span className="mini-stat-label">Blockchain</span>
                <span className="mini-stat-value">✓ Solana</span>
              </div>
            </div>
            <div className="hero-cta-container">
              <button className="hero-cta-button" onClick={scrollToPacks}>
                <span>Ver Packs Disponibles</span>
                <FaArrowRight className="cta-icon" />
              </button>
              <div className="hero-trust-badge">
                <FaShieldAlt /> Blockchain Security
              </div>
            </div>
          </div>

          <div className="hero-graphic">
            <div className="product-display">
              <div className="product-glow"></div>

              {/* CARRUSEL DE IMÁGENES DEL PRODUCTO */}
              <div className="hero-product-carousel">
                <Swiper
                  modules={[Autoplay]}
                  spaceBetween={0}
                  slidesPerView={1}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                  }}
                  loop={true}
                  className="hero-swiper"
                  touchReleaseOnEdges={true}
                  resistance={true}
                  resistanceRatio={0.85}
                >
                  <SwiperSlide>
                    <img src={reanimeitorImage} alt="reanimeitor" className="hero-product-image" />
                  </SwiperSlide>
                  <SwiperSlide>
                    <img src={packImage} alt="Pack 24 latas" className="hero-product-image" />
                  </SwiperSlide>
                </Swiper>

                {/* Indicadores visuales del carrusel */}
                <div className="carousel-indicators-hero">
                  <span className="hero-indicator"></span>
                  <span className="hero-indicator"></span>
                </div>
              </div>

              <div className="price-tag-large">
                <span className="price-currency">Genesis</span>
                <span className="price-value">Edition</span>
                <span className="token-bonus-large">+BGP</span>
              </div>
              <div className="product-tags">
                <span className="product-tag">Blockchain</span>
                <span className="product-tag">NFC</span>
                <span className="product-tag">Autenticación</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS SECTION */}
      <section className="home-stats-section">
        <div className="stats-container">
          <div className="section-header-mini">
            <h2>Nuestra comunidad</h2>
            <div className="header-line-small"></div>
          </div>
          {isMobile ? (
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={16}
              slidesPerView={1.2}
              centeredSlides={true}
              pagination={{ clickable: true, dynamicBullets: true }}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              loop={true}
              className="stats-carousel"
            >
              {statsData.map((stat, idx) => (
                <SwiperSlide key={idx}>
                  <div className="stat-card-mobile">
                    <div className="stat-icon-wrapper" style={{ color: stat.color }}>
                      {stat.icon}
                    </div>
                    <div className="stat-value">{stat.value}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="stats-grid">
              {statsData.map((stat, idx) => (
                <div key={idx} className="stat-card">
                  <div className="stat-icon-wrapper" style={{ color: stat.color }}>
                    {stat.icon}
                  </div>
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* TABS NAVIGATION */}
      <nav className="tabs-navigation">
        <div className="tabs-container">
          <button className={`tab-btn ${activeTab === 'products' ? 'active' : ''}`} onClick={() => setActiveTab('products')}>
            <FaShoppingCart className="tab-icon" /> <span>Packs</span>
          </button>
          <button className={`tab-btn ${activeTab === 'tokens' ? 'active' : ''}`} onClick={() => setActiveTab('tokens')}>
            <FaCoins className="tab-icon" /> <span>BGP</span>
          </button>
        </div>
      </nav>

      <div className="content-wrapper">
        <main className="home-content">
          {activeTab === 'products' && (
            <div className="tab-panel fade-in">
              <div className="section-header">
                <h2>Packs de Acceso</h2>
                <div className="header-line"></div>
              </div>

              {/* ========== VERSIÓN ESCRITORIO ========== */}
              {!isMobile ? (
                <div className="packs-layout">
                  <div className="packs-left-column">
                    <div className="fixed-product-image">
                      <div className="product-glow-small"></div>

                      {/* CARRUSEL DE IMÁGENES EN PACKS LEFT COLUMN */}
                      <div className="packs-product-carousel">
                        <Swiper
                          modules={[Autoplay]}
                          spaceBetween={0}
                          slidesPerView={1}
                          autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true
                          }}
                          loop={true}
                          className="packs-swiper"
                          touchReleaseOnEdges={true}
                          resistance={true}
                          resistanceRatio={0.85}
                        >
                          <SwiperSlide>
                            <img src={reanimeitorImage} alt="reanimeitor" className="fixed-can-image" />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img src={packImage} alt="Pack 24 latas" className="fixed-can-image" />
                          </SwiperSlide>
                        </Swiper>

                        {/* Indicadores del carrusel */}
                        <div className="packs-carousel-indicators">
                          <span className="packs-indicator"></span>
                          <span className="packs-indicator"></span>
                        </div>
                      </div>

                      <div className="product-energy-ring-small">
                        <div className="energy-ring-small"></div>
                      </div>
                      <div className="genesis-badge">Genesis Can</div>
                    </div>
                  </div>
                  <div className="packs-right-column">

                    <div className="packs-carousel-wrapper">
                      <div className="packs-carousel-container">
                        <button className="carousel-arrow carousel-arrow-left" onClick={prevPack}>←</button>
                        <div className="packs-carousel-desktop">
                          {packsData.map((pack, idx) => (
                            <div key={pack.id} className={`pack-card-modern ${currentPack === idx ? 'active' : ''}`}>
                              <div className="pack-badge" style={{ background: pack.color }}>{pack.badge}</div>
                              <h3>{pack.name}</h3>
                              <p className="pack-description">{pack.description}</p>
                              <div className="pack-features">
                                {pack.features.map((feat, i) => (
                                  <div key={i} className="pack-feature">
                                    <span className="feature-icon">{feat.icon}</span>
                                    <span className="feature-text">{feat.label}</span>
                                  </div>
                                ))}
                              </div>
                              <div className="pack-pricing">
                                <div className="price-wrapper">
                                  <span className="price-currency-sm">€</span>
                                  <span className="price-value-lg">{formatPrice(pack.price)}</span>
                                </div>
                                {pack.bgpTokens > 0 && (
                                  <div className="token-bonus-pack">
                                    <FaGift className="bonus-icon" />
                                    <span>+{pack.bgpTokens} BGP</span>
                                  </div>
                                )}
                              </div>
                              <button className="buy-button-premium" onClick={() => handleBuy(pack)} disabled={isProcessing}>
                                {isProcessing ? <><FaSpinner className="spinning-icon" /> Procesando...</> : <><FaShoppingCart className="button-icon" /> Comprar ahora <FaArrowRight className="button-icon-right" /></>}
                              </button>
                              {!user && <p className="login-warning"><FaShieldAlt /> Inicia sesión para comprar</p>}
                            </div>
                          ))}
                        </div>
                        <button className="carousel-arrow carousel-arrow-right" onClick={nextPack}>→</button>
                      </div>
                      <div className="carousel-indicators">
                        {packsData.map((_, idx) => (
                          <span key={idx} className={`carousel-dot ${currentPack === idx ? 'active' : ''}`} onClick={() => setCurrentPack(idx)}></span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                /* ========== VERSIÓN MÓVIL: CARRUSEL HORIZONTAL (SWIPER) ========== */
                <div className="packs-mobile-carousel-wrapper">
                  <Swiper
                    modules={[Pagination]}
                    spaceBetween={20}
                    slidesPerView={1}
                    pagination={{ clickable: true, dynamicBullets: true }}
                    className="packs-mobile-swiper"
                  >
                    {packsData.map((pack) => (
                      <SwiperSlide key={pack.id}>
                        <div className="mobile-pack-card">
                          <div className="mobile-pack-image-wrapper">
                            {/* CARRUSEL DE IMÁGENES DUAL PARA MÓVIL */}
                            <Swiper
                              modules={[Autoplay]}
                              spaceBetween={0}
                              slidesPerView={1}
                              autoplay={{
                                delay: 3000,
                                disableOnInteraction: false
                              }}
                              loop={true}
                              className="mobile-product-swiper"
                            >
                              <SwiperSlide>
                                <img src={reanimeitorImage} alt="reanimeitor" className="mobile-pack-image" />
                              </SwiperSlide>
                              <SwiperSlide>
                                <img src={packImage} alt="Pack 24 latas" className="mobile-pack-image" />
                              </SwiperSlide>
                            </Swiper>

                            {/* Indicadores del carrusel móvil */}
                            <div className="mobile-carousel-indicators">
                              <span className="mobile-indicator"></span>
                              <span className="mobile-indicator"></span>
                            </div>

                            <div className="mobile-pack-badge" style={{ background: pack.color }}>{pack.badge}</div>
                          </div>
                          <h3>{pack.name}</h3>
                          <p className="mobile-pack-description">{pack.description}</p>
                          <div className="mobile-pack-features">
                            {pack.features.slice(0, 2).map((feat, i) => (
                              <div key={i} className="mobile-feature">
                                <span className="feature-icon">{feat.icon}</span>
                                <span className="feature-text">{feat.label}</span>
                              </div>
                            ))}
                          </div>
                          <div className="mobile-pack-pricing">
                            <div className="price-wrapper">
                              <span className="price-currency-sm">€</span>
                              <span className="price-value-lg">{formatPrice(pack.price)}</span>
                            </div>
                            {pack.bgpTokens > 0 && (
                              <div className="token-bonus-pack">
                                <FaGift className="bonus-icon" />
                                <span>+{pack.bgpTokens} BGP</span>
                              </div>
                            )}
                          </div>
                          <button className="buy-button-premium mobile-buy-button" onClick={() => handleBuy(pack)} disabled={isProcessing}>
                            {isProcessing ? <><FaSpinner className="spinning-icon" /> Procesando...</> : <><FaShoppingCart className="button-icon" /> Comprar ahora</>}
                          </button>
                          {!user && <p className="login-warning"><FaShieldAlt /> Inicia sesión</p>}
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <div className="swipe-hint">
                    <span>👆 Desliza para ver más →</span>
                  </div>
                </div>
              )}

              {/* BGP INCLUDED SECTION */}
              <div className="bgp-included-premium">
                <div className="bgp-included-header">
                  <FaGift className="bgp-gift-icon" />
                  <h3>Token BGP Incluido Gratis</h3>
                </div>
                <div className="bgp-included-content">
                  <p className="bgp-highlight"><strong>Cada pack incluye tokens Bitcoin Global Pay (BGP) GRATIS</strong></p>
                  <p>Estos tokens sirven para programar NFC y asignarles NFTs. Serán canjeables cuando el contador llegue a 0. Este contador estará disponible a través de mi cuenta.</p>
                  <div className="bgp-benefits-grid">
                    <div className="benefit-item"><span className="benefit-icon">🪙</span><span>Tokens incluidos</span></div>
                    <div className="benefit-item"><span className="benefit-icon">💰</span><span>Acumulables</span></div>
                    <div className="benefit-item"><span className="benefit-icon">⚡</span><span>Canjeables</span></div>
                    <div className="benefit-item"><span className="benefit-icon">🔒</span><span>Blockchain</span></div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'tokens' && (
            <div className="tab-panel fade-in">
              <div className="section-header">
                <h2>Bitcoin Global Pay</h2>
                <div className="header-line"></div>
              </div>

              {isMobile ? (
                <div className="bgp-carousel-section">
                  <Swiper
                    modules={[Pagination, Autoplay]}
                    spaceBetween={16}
                    slidesPerView={1}
                    pagination={{ clickable: true, dynamicBullets: true }}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    loop={true}
                    className="bgp-info-carousel"
                  >
                    {bgpInfoData.map((info, idx) => (
                      <SwiperSlide key={idx}>
                        <div className="bgp-info-card-premium">
                          <div className="bgp-card-header" style={{ background: `linear-gradient(135deg, ${info.color}20, transparent)` }}>
                            <div className="bgp-icon-large" style={{ color: info.color }}>{info.icon}</div>
                            <h3>{info.title}</h3>
                          </div>
                          <div className="bgp-card-body">
                            <p className="bgp-description">{info.description}</p>
                            <ul className="bgp-points-list">
                              {info.points.map((point, i) => <li key={i}>{point}</li>)}
                            </ul>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              ) : (
                <div className="bgp-grid-premium">
                  {bgpInfoData.map((info, idx) => (
                    <div key={idx} className="bgp-card-premium">
                      <div className="bgp-card-header" style={{ background: `linear-gradient(135deg, ${info.color}15, transparent)` }}>
                        <div className="bgp-icon-wrapper" style={{ color: info.color }}>{info.icon}</div>
                        <h3>{info.title}</h3>
                      </div>
                      <div className="bgp-card-body">
                        <p className="bgp-description">{info.description}</p>
                        <ul className="bgp-points-list">
                          {info.points.map((point, i) => <li key={i}>{point}</li>)}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="cta-section-premium">
                <div className="cta-content">
                  <h4>¿Listo para obtener tus tokens BGP?</h4>
                  <p>Cada pack de reanimeitor Trace incluye tokens BGP gratis. ¡Acumula y canjea cuando quieras!</p>
                  <button className="cta-button-premium" onClick={() => setActiveTab('products')}>
                    <FaBolt className="cta-icon" /> <span>Ver Packs Disponibles</span> <FaArrowRight className="cta-icon-right" />
                  </button>
                </div>
              </div>

              <div className="counter-info-premium">
                <div className="counter-icon"><FaClock /></div>
                <div className="counter-text">
                  <h4>Contador de Retiro</h4>
                  <p>Los tokens BGP pueden ser retirados cuando el contador de retiro esté a 0. Mantente atento a las actualizaciones.</p>
                </div>
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default Home;